export const DESKTOP_BATCH = {
    initial: 25,
    subsequent: 15,
    initialMinimum: 15,
    initialShimmer: 10,
} as const;

/** Desktop AB variant: ML5+SL5+ML10+SL5 initial, then ML10+SL5 per loadNext. */
export const DESKTOP_VARIANT_BATCH = {
    initial: 15,
    subsequent: 10,
    initialMinimum: 15,
    initialShimmer: 10,
} as const;

export const MOBILE_BATCH = {
    initial: 20,
    subsequent: 6,
    initialMinimum: 6,
    initialShimmer: 4,
} as const;

/** MW AB variant: ML14+SL6 initial (rows 2, 5, 8), then ML4+SL2 per loadNext. */
export const MOBILE_VARIANT_BATCH = {
    initial: 14,
    subsequent: 4,
    initialMinimum: 6,
    initialShimmer: 4,
} as const;

/** Sub-module AB variant: 3 ML+SL rows per page (desktop 10+5). */
export const DESKTOP_SUBMODULE_BATCH = {
    initial: 10,
    subsequent: 10,
    initialMinimum: 10,
    initialShimmer: 15,
} as const;

/** Sub-module AB variant: 3 ML+SL rows per page (mobile 4+2). */
export const MOBILE_SUBMODULE_BATCH = {
    initial: 4,
    subsequent: 4,
    initialMinimum: 4,
    initialShimmer: 6,
} as const;

export const PDP_INFINITE_SCROLL_FEED_ROWS_PER_BLOCK = 3;

export const DEFAULT_CAROUSEL_CAPACITY = 10;
/** Product tiles before the feed carousel View All tile. */
export const FEED_CAROUSEL_ITEM_COUNT = 11;
/** Two desktop pages of 6 when the carousel has no trailing View All tile. */
const FEED_CAROUSEL_ITEM_COUNT_WITHOUT_VIEW_ALL = 12;
export const FEED_CAROUSEL_ITEMS_TO_SHOW_RESP = 6;
/** Mobile tile width is pinned in getPdpFeedCarouselLayout, so this only drives eager image load + shimmer count. */
export const FEED_CAROUSEL_ITEMS_TO_SHOW_MOBILE = 3;

export const getPdpFeedCarouselVariables = (
    isSubModuleVariant: boolean
): {
    personalizedItemsCount: number;
} => ({
    personalizedItemsCount: isSubModuleVariant
        ? FEED_CAROUSEL_ITEM_COUNT_WITHOUT_VIEW_ALL
        : DEFAULT_CAROUSEL_CAPACITY,
});

export const DESKTOP_SENTINEL_ROOT_MARGIN = '0px 0px 1000px 0px';
export const MOBILE_SENTINEL_ROOT_MARGIN = '0px 0px 900px 0px';

/** Topsort ID pool size (not inflated count). */
export const PDP_INFINITE_SCROLL_SPONSORED_PAGE_SIZE = 110;
export const PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT = 10;
export const PDP_INFINITE_SCROLL_SL_INITIAL = 10;
/** Initial inflate: carousel 10 + first 2 grid SL rows. */
export const PDP_INFINITE_SCROLL_SL_INITIAL_INFLATE =
    PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT + PDP_INFINITE_SCROLL_SL_INITIAL;
export const PDP_INFINITE_SCROLL_SL_SUBSEQUENT = 5;

export const PDP_MW_INFINITE_SCROLL_SL_INITIAL = 6;
export const PDP_MW_INFINITE_SCROLL_SL_INITIAL_INFLATE =
    PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT + PDP_MW_INFINITE_SCROLL_SL_INITIAL;
export const PDP_MW_INFINITE_SCROLL_SL_SUBSEQUENT = 2;

export const PDP_SUBMODULE_SL_INITIAL = 5;
export const PDP_SUBMODULE_SL_INITIAL_INFLATE =
    PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT + PDP_SUBMODULE_SL_INITIAL;
export const PDP_MW_SUBMODULE_SL_INITIAL = 2;
export const PDP_MW_SUBMODULE_SL_INITIAL_INFLATE =
    PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT + PDP_MW_SUBMODULE_SL_INITIAL;

export const PDP_INFINITE_SCROLL_ITEMS_PER_ROW = 5;
export const PDP_MW_INFINITE_SCROLL_ITEMS_PER_ROW = 2;

/** 0-indexed row indices 1, 4, 7… (= display rows 2, 5, 8…) up to row 60. */
export const PDP_SPONSORED_ROW_INDICES: readonly number[] = Array.from(
    { length: 20 },
    (_, i) => 1 + i * 3
);
